import { render, staticRenderFns } from "./jr.vue?vue&type=template&id=14f787b1&scoped=true&"
import script from "./jr.vue?vue&type=script&lang=js&"
export * from "./jr.vue?vue&type=script&lang=js&"
import style0 from "./jr.vue?vue&type=style&index=0&id=14f787b1&lang=less&scoped=true&"
import style1 from "./jr.vue?vue&type=style&index=1&id=14f787b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f787b1",
  null
  
)

export default component.exports